export const en = {
  loader: {
    loading: 'Loading…'
  }
};
